var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sections"},[_c('a',{class:_vm.active ? 'active sliding' : 'sliding',attrs:{"href":_vm.route},on:{"mouseenter":_vm.linkHover,"mouseleave":_vm.linkFree}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_c('span',{ref:"linkSpan",staticClass:"hover-underline-animation"},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }